import api from '../../api/mas-athena';

const state = {
    activities: [],
    activity: []
};

const getters = {
    allActivities: state => state.activities,
    activity: state => state.activity
};

const actions = {
    async fetchActivities({ commit }, category_id) {
        const responce = await api.fetchActivities(category_id);

        commit('setActivities', responce.data.results.activity_packages);
    },
    async getActivity({ commit }, activity_id) {
        const responce = await api.getActivity(activity_id);

        commit('setActivity', responce.data.results);
    }
};

const mutations = {
    setActivities: (state, activities) => {
        state.activities = activities;
    },
    setActivity: (state, activity) => {
        state.activity = activity;
    },    
};

export default {
    state,
    getters,
    actions,
    mutations
}